export default __webpack_public_path__ + "static/media/Nitroxgallery_12.52093cd3.jpg";